import { useEffect, useRef, useState } from "react";

export const useQuantity = (props) => {
  const { initialValue, onChange } = props;
  const [quantity, setQuantity] = useState(initialValue);
  const timeoutRef = useRef(null);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (quantity >= 1) {
        onChange(quantity);
      }
    }, 1000);
  }, [quantity]);

  return {
    quantity,
    setQuantity,
  };
};
